/** @format */

import { post } from '@/utils/httpWrap';

/**
 * 图片上传
 */
export const uploadImage = (params: { fileBase64?: string; parkId?: string; fileName?: string }): Promise<any> => {
  return post('/bangdao/saasapi/v1/image/upload', params);
};
